import React, { useState, useEffect } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";
import { red } from "@mui/material/colors";

// Initialize Highcharts modules
HCMore(Highcharts);
solidGauge(Highcharts);

// ...imports stay the same

const PerformanceBar = (props) => {
  const makeOptions = (data, peerData) => ({
    chart: {
      type: "bar",
      backgroundColor: "transparent",
      borderWidth: 0,
      plotBorderWidth: 0,
      height: 300,              // desktop height
    },
    plotOptions: {
      bar: {
        colorByPoint: true,
        groupPadding: 0.1,
        pointPadding: 0.1,
        borderWidth: 0,
      },
    },
    colors: ["#E54126", "#F49E1D", "#29B3AF", "#2F9CCA", "#24346E"],
    title: { text: "" },

    // NOTE: In a bar chart, categories are shown on the "y" side visually,
    // but Highcharts still uses xAxis for categories (because the chart is inverted).
    xAxis: {
      gridLineColor: "#bebebc",
      gridLineWidth: 1,
      categories: [
        "Experience",
        "Qualification",
        "Training",
        "Systems",
      ],
      labels: {
        useHTML: true,               // you’re using HTML labels
        // DON'T hard-code font-size in the formatter HTML.
        formatter: function () {     // just return the text/HTML
          return `<span>${this.value}</span>`;
        },
        style: {
          fontSize: "13px",          // desktop size
          fontFamily: "Verdana, sans-serif",
          fontWeight: "600",
          color: "#666666",
        },
      },
    },

    yAxis: {
      min: 0,
      gridLineWidth: 0,
      title: { enabled: false },
      labels: { enabled: false },
    },

    legend: { enabled: false },
    credits: { enabled: false },

    tooltip: {
      enabled: true,
      formatter: function () {
        return `<b>${this.x}</b><br/>${this.series.name}: ${Highcharts.numberFormat(this.y, 0)}`;
      },
      positioner: function (boxWidth, boxHeight, point) {
        const x = point.plotX + this.chart.plotLeft - boxWidth / 2;
        const y = point.plotY + this.chart.plotTop - boxHeight + 10;
        return { x, y };
      },
    },

    series: [
      {
        name: "My Score",
        data: data,
        color: "#CCCCCC",
        dataLabels: { enabled: false },
      },
      {
        name: "Peers Score",
        data: peerData,
        colors: ["#93AEC7", "#93AEC7", "#93AEC7", "#93AEC7"],
        dataLabels: { enabled: false },
      },
    ],

    // >>> This makes the label font-size (and chart height) smaller ONLY on small screens
    responsive: {
      rules: [{
        condition: { maxWidth: 576 },          // mobile breakpoint
        chartOptions: {
          chart: { height: 220 },
          xAxis: {
            labels: {
              style: { fontSize: "10px" },     // mobile size
            },
          },
          plotOptions: {
            bar: { pointPadding: 0.05, groupPadding: 0.05 },
          },
        },
      }],
    },
  });

  const [options, setOptions] = React.useState(makeOptions(props?.data || [], props?.peerData || []));

  useEffect(() => {
    setOptions(makeOptions(props?.data || [], props?.peerData || []));
  }, [props.data, props.peerData]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PerformanceBar;



